<template>
  <div class="analyzes-chart">
    <a id="dl" class="d-none" href="" :download="`${getChartName}.png`">Download Canvas</a>
    <h2 class="d-block">{{$t('analyzes.progress')}}</h2>
    <div class="row">
      <div  v-if="chartData.length > 0"  class="offset-1 my-4 col-10 d-flex flex-row justify-content-between">
        <div class="d-flex">
          <img src="~@/assets/images/right-arrow.svg" @click="moveBack()" style="cursor: pointer" class="icon__arrow mr-3" alt="">
          <h6 style="">{{getChartName}}</h6>
        </div>
       
        <button  @click="saveChart()" class="border-0 bg-transparent">
          <img src="~@/assets/images/download-chart.svg" alt="">
        </button>
      </div>
      <div class="offset-2 col-8">
        <canvas id="myChart" width="700" height="320"></canvas>
      </div>
    </div>
    <div class="row mt-3" v-if="chartData.length > 0">
      <div class="col">
        <p class="font-weight-bold">{{ $t('analyzes.progress') }}: {{selectedChartData['Unit']}}</p>
        <p>
          Норма:
          <span v-html="selectedChartData['ReferenceRange'].length > 30 ? '<br>' : ''"></span>
          <span v-html="selectedChartData['ReferenceRange'].replace(/\n/gi,'<br>')"></span></p>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import moment from 'moment'
import Chart from 'chart.js'

export default {
  props: {
    chart_id: {
      type: [String, Number],
      required: true,
    },
    marker_id: {
      type: [String, Number],
      required: true,
    }
  },
  data() {
    return {
      chartObject:null,
    };
  },
  computed: {
    ...mapGetters([
      'chartData'
    ]),
    selectedChartData() {
      return this.chartData ? this.chartData[this.marker_id] : null
    },
    getChartName(){
      return this.chartData.length ? this.chartData[this.marker_id]['Marker'] : ''
    },

  },

  methods: {
    saveChart(){
      let link = document.getElementById('dl')
      window.chart.options.title.display = true
      window.chart.options.animation.duration = 0

      window.chart.update();
      setTimeout(()=>{
        link.href = document.getElementById('myChart').toDataURL('image/png');
        window.chart.options.title.display = false
        window.chart.options.animation.duration = 1000
        window.chart.update();
        link.click()
      },600)

    },
    zip(x, y) {
      let array = [];
      for (let i = 0; i < x.length; i++) {
        array.push([x[i], y[i]])
      }
      return array
    },
    regressData(x, y) {
      let resultArray = []
      let xm = this.avarageValue(x)
      let ym = this.avarageValue(y)
      let x2m = this.avarageValue(x.map(item => Math.pow(item, 2)))
      let x3m = this.avarageValue(x.map(item => Math.pow(item, 3)))
      let x4m = this.avarageValue(x.map(item => Math.pow(item, 4)))

      let xym = this.avarageValue(this.zip(x, y).map(item => item[0] * item[1]))
      let x2ym = this.avarageValue(this.zip(x, y).map(item => item[0] * item[0] * item[1]))

      let sxx = x2m - xm * xm
      let sxy = xym - xm * ym
      let sxx2 = x3m - xm * x2m
      let sx2x2 = x4m - x2m * x2m
      let sx2y = x2ym - x2m * ym

      let b = (sxy * sx2x2 - sx2y * sxx2) / (sxx * sx2x2 - sxx2 * sxx2)
      let c = (sx2y * sxx - sxy * sxx2) / (sxx * sx2x2 - sxx2 * sxx2)
      let a = ym - b * xm - c * x2m

      const abc = function (a, b, c, xx) {
        return (a + b * xx) + (c * xx * xx)
      }
      for (let i = 0; i < x.length; i++) {
        let result = parseFloat(abc(a, b, c, x[i]))
        resultArray.push(result)
      }
      return resultArray
    },
    avarageValue(arr) {
      return arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0) / arr.length
    },
    buildChart() {
      let chartData = this.chartData[this.marker_id]
      let data = chartData['Data']
      let positiveRange = chartData['ReferenceRange'].replace(/[a-zA-Z]/gi, '').split('–')
      let x = data.map((item) => moment(item['Date']).unix())
      let y = data.map((item) => item['Value'])
      let regressData = this.regressData(x, y);

      let mapDataOriginal = data.map((item) => {
        return {
          x: moment(item['Date']).unix(),
          y: item['Value']
        }
      })
      let regressionMapResult = regressData.map((item, idx) => {
        return {
          x: mapDataOriginal[idx],
          y: item
        }
      })

      let legends = mapDataOriginal.map((item) => moment.unix(item.x).format('DD.MM.YY'))

      let ctx = document.getElementById('myChart');
      this.chartObject = new Chart(ctx, {
        type: 'line',
        data: {
          labels: legends,
          datasets: [
            {
              backgroundColor: '#04A9F4',
              borderColor: '#04A9F4',
              data: mapDataOriginal,
              fill: false,
              borderWidth: 3,
              pointRadius: 8,
              pointHoverRadius:12,
              pointBackgroundColor: 'white',
              hoverBackgroundColor:'white',
              pointBorderColor: function (point) {
                let idx = point.dataIndex
                if (point.dataset.data[idx].y >= positiveRange[0] && point.dataset.data[idx].y <= positiveRange[1]) {
                  return 'rgb(30,158,207)'
                } else {
                  return 'rgb(224,18,5)'
                }
              }
            },
            {
              backgroundColor: 'red',
              borderColor: 'red',
              borderDash: [10, 10],
              data: regressionMapResult,
              fill: false,
              borderWidth: 1,
              pointRadius: 0,
              pointHoverRadius:0
            }
          ]

        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
              //beginAtZero: true
              },
            }],
            xAxes:[{
              offset: mapDataOriginal.length <= 1
            }]
          },
          legend:false,
          title: {
            display:false,
            fontSize:'27',
            padding:15,
            fontStyle:'normal',
            text:this.getChartName
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 10,
              bottom: 10
            }
          }
        }
      });
      window.chart = this.chartObject
    },
    moveBack(){
      this.$router.back()
    }
  },
  mounted() {
    if (this.chartData.length === 0) {
      this.$store.dispatch('getAnalyzesChart', {id: this.chart_id}).then(() => {
        this.buildChart()
      });
    } else {
      this.buildChart()
    }

  },
}
</script>

<style lang="scss">
.analyzes {
  & > h2 {
    font-size: 42px;
    color: #0a4766;
    margin-top: 25px;
  }

  & > .item {
    min-height: 90px;

    &:not(:first-child) {
      border-bottom: 2px solid rgba(163, 190, 204, 0.25);
    }

    & > .download {
      & > *:not(:last-child) {
        margin-right: 10px;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  iframe.content {
    width: 100%;
    min-height: 75vh;
  }
}
</style>
